var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useState } from "react";
import { SkipToMainContent } from "@react-md/link";
import { LayoutAppBar } from "./LayoutAppBar";
import { LayoutMain } from "./LayoutMain";
import { LayoutNavigation } from "./LayoutNavigation";
import { useLayoutConfig } from "./LayoutProvider";
import { isMiniLayout } from "./utils";
/**
 * The only purpose of this component is to render the children and different
 * parts of the `Layout` depending on the current layout that is active. Since
 * the `Layout` component defines the provider itself, this has to be a child
 * component to get the resolved `layout` type.
 *
 * @remarks \@since 2.7.0
 * @internal
 */
export function LayoutChildren(_a) {
    var _b;
    var _c = _a.id, id = _c === void 0 ? "layout" : _c, propAppBar = _a.appBar, appBarProps = _a.appBarProps, customTitle = _a.customTitle, title = _a.title, titleProps = _a.titleProps, navToggle = _a.navToggle, navToggleProps = _a.navToggleProps, _d = _a.navAfterAppBar, navAfterAppBar = _d === void 0 ? false : _d, propNav = _a.nav, propMiniNav = _a.miniNav, miniNavItems = _a.miniNavItems, navHeader = _a.navHeader, navHeaderProps = _a.navHeaderProps, navHeaderTitle = _a.navHeaderTitle, navHeaderTitleProps = _a.navHeaderTitleProps, closeNav = _a.closeNav, closeNavProps = _a.closeNavProps, treeProps = _a.treeProps, navProps = _a.navProps, skipProps = _a.skipProps, mainProps = _a.mainProps, children = _a.children;
    var mainId = (mainProps === null || mainProps === void 0 ? void 0 : mainProps.id) || id + "-main";
    var fixedAppBar = (_b = appBarProps === null || appBarProps === void 0 ? void 0 : appBarProps.fixed) !== null && _b !== void 0 ? _b : typeof propAppBar === "undefined";
    var _e = useLayoutConfig(), layout = _e.layout, visible = _e.visible;
    var mini = isMiniLayout(layout);
    var _f = useState(visible), miniHidden = _f[0], setMiniHidden = _f[1];
    // when the layout changes, the hidden state for the mini drawer must also be
    // updated
    useEffect(function () {
        setMiniHidden(visible);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [layout]);
    var appBar = propAppBar;
    if (typeof appBar === "undefined") {
        appBar = (React.createElement(LayoutAppBar, __assign({}, appBarProps, { customTitle: customTitle, title: title, titleProps: titleProps, navToggle: navToggle, navToggleProps: navToggleProps })));
    }
    var nav = propNav;
    if (typeof nav === "undefined") {
        nav = (React.createElement(LayoutNavigation, __assign({ header: navHeader, headerProps: navHeaderProps, headerTitle: navHeaderTitle, headerTitleProps: navHeaderTitleProps, closeNav: closeNav, closeNavProps: closeNavProps, treeProps: treeProps }, navProps, { onEntered: function (node, isAppearing) {
                var _a;
                (_a = navProps === null || navProps === void 0 ? void 0 : navProps.onEntered) === null || _a === void 0 ? void 0 : _a.call(navProps, node, isAppearing);
                setMiniHidden(true);
            }, onExit: function (node) {
                var _a;
                (_a = navProps === null || navProps === void 0 ? void 0 : navProps.onExit) === null || _a === void 0 ? void 0 : _a.call(navProps, node);
                setMiniHidden(false);
            } })));
    }
    var miniNav = propMiniNav;
    if (mini && treeProps && typeof miniNav === "undefined") {
        var miniTreeProps = treeProps;
        if (miniNavItems) {
            miniTreeProps = __assign(__assign({}, miniTreeProps), { navItems: miniNavItems });
        }
        miniNav = (React.createElement(LayoutNavigation, __assign({ header: navHeader, headerProps: navHeaderProps, headerTitle: navHeaderTitle, headerTitleProps: navHeaderTitleProps, closeNav: closeNav, closeNavProps: closeNavProps, treeProps: miniTreeProps }, navProps, { mini: true, hidden: miniHidden })));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(SkipToMainContent, __assign({}, skipProps, { mainId: mainId })),
        navAfterAppBar && appBar,
        nav,
        !navAfterAppBar && appBar,
        miniNav,
        React.createElement(LayoutMain, __assign({ headerOffset: fixedAppBar }, mainProps, { id: mainId, mini: mini }), children)));
}
//# sourceMappingURL=LayoutChildren.js.map